import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export const Dashboard = () => {
  const navigate = useNavigate();
  React.useEffect(() => {
    navigate("/store/orders");
  }, []);
  return <div style={{ minHeight: "80vh" }}>Store</div>;
};
